<template>
    <div id="card">
      <div class="nav-card">
        <div class="nav-header">
          <ul class="nav-link">
            <li>
              <router-link :to="{path:languageTypeUrl,query:{navIndex:0}}">首页</router-link>
            </li>
            <li v-if="$route.matched[1]">
              &gt;
              <router-link :to="$route.matched[1].path+'?navIndex=0'">{{$route.matched[1].meta.title}}</router-link>
            </li>
            <li v-if="$route.matched.length > 2">
              &gt;
              <router-link :to="$route.matched[2].path+'?navIndex=0'">{{$route.matched[2].meta.title}}</router-link>
            </li>
          </ul>
          <ul class="nav-bar">
            <li v-for="(item,index) in topBarList" :key="index">
              <router-link :class="[$route.path.indexOf(item.key)!==-1?'link-active':'']" :to='{path:item.url,query:{random:Math.random()}}' :replace="index>1?true:''">{{item.title}}</router-link>
            </li>
          </ul>
        </div>
        <div class="nav-body">
          <router-view></router-view>
        </div>
      </div>
    </div>
</template>
<script>
export default {
    data () {
        return {
            languageTypeUrl: ''
        }
    },
    props: {
        topBarList: {
            type: Array,
            default () {
                return []
            }
        }
    },
    mounted () {
        if (localStorage.languageType && (localStorage.languageType !== 'undefined')) {
            this.languageTypeUrl = '/' + localStorage.languageType + '/index'
        } else {
            this.languageTypeUrl = '/zh-CN/index'
        }
    }
}
</script>
<style lang="scss" scoped>
#card {
	  .nav-card {
			max-width: 1200px;
			position: relative;
			margin: 0 auto;
			margin-top: -91px;
			padding-bottom: 100px;
			.nav-header {
				width: 100%;
				box-sizing: border-box;
				border-bottom: 1px solid #edaa42;
				ul.nav-link {
					line-height: 30px;
					font-size: 14px;
					li {
						display: inline;
						color: #fff;
						a {
							color: inherit;
						}
						&:last-child>a {
							color: #edaa42;
						}
					}
				}
				ul.nav-bar {
					background-color: #fff;
					width: 100%;
					display: table;
					table-layout: fixed;
					li {
						display: table-cell;
						text-align: center;
						height: 60px;
						line-height: 60px;
						border-right: 1px solid #e9e9e9;
						&:hover a{
							color: #fff;
							background-color: #edaa42;
						}
						&:last-child{
							border-right: 0;
						}
						>a {
							display: block;
							width: auto;
							height: 100%;
							text-align: center;
							color: #646464;
							&.link-active {
								color: #fff;
								background-color: #edaa42;
							}
						}
					}
				}
			}
			.nav-body {
				overflow: hidden;
				box-shadow: 5px 5px 10px #eeedeb, /*左*/
				-5px 5px 10px #eeedeb,;
				background: #fff;
			}
		}
}
</style>



// WEBPACK FOOTER //
// src/components/card.vue